import { render, staticRenderFns } from "./PasswordForget.vue?vue&type=template&id=69326ded&scoped=true&"
import script from "./PasswordForget.vue?vue&type=script&lang=js&"
export * from "./PasswordForget.vue?vue&type=script&lang=js&"
import style0 from "./PasswordForget.vue?vue&type=style&index=0&id=69326ded&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69326ded",
  null
  
)

export default component.exports